import {Identifiable} from "./interface/Identifiable";

export enum Roles {

    ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
    APP_USER= 'APP_USER',
    SIQUAL_USER_SHOW= 'SIQUAL_USER_SHOW',
    ROLE_WORKFLOW_IMPORT_SHOW = 'ROLE_WORKFLOW_IMPORT_SHOW',
    ROLE_WORKFLOW_IMPORT_UPDATE = 'ROLE_WORKFLOW_IMPORT_UPDATE',
    ROLE_WORKFLOW_EXPORT_SHOW = 'ROLE_WORKFLOW_EXPORT_SHOW',
    ROLE_WORKFLOW_EXPORT_UPDATE = 'ROLE_WORKFLOW_EXPORT_UPDATE',
}

export enum Profiles {
    ROLE_SUPER_ADMIN = 'Super Administrateur',
    ROLE_ADMIN = 'Administrateur',
    ROLE_USER = 'Utilisateur',
}

export type AppPermissions = Profiles | Roles;

export class Group implements Identifiable {

    constructor(
        readonly id: number,
        public name: string,
        public roles: Array<Roles | string>,
    ) {
    }
}
